module.exports = __webpack_public_path__ + "img/nature-62.0d58476a.jpg";